<template>
    <div id="fuel_pump_mapping" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleHeader" v-if="$route.params.id > 0">Update Fuel Pump Mapping</span>
                    <span class="page-title" id="vehicleHeader" v-else>Add Fuel Pump Mapping</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackFuelMappingList" >
                        <i class="fp-back"> </i>    Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="VehicleFeatureForm">
                                <!-- <div class="form-row row-cols-md-4 row-cols-1"> -->
                                    <template>
                                         <div class="purchase-order-create-main form-group table-responsive-sm">
                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th scope="col" class="require" style="width:1000px">Location</th>
                                                        <th scope="col" class="require" style="width:400px">Tank</th>
                                                        <th scope="col" class="require" style="width:400px">Pump</th>
                                                        <!-- <th scope="col" style="width:400px">Action</th> -->
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(fuelMap, index) in fuelTankPumpMapper" :key="index">
                                                        <td>
                                                            <v-select v-model="fuelMap.location" name="location" placeholder="Select Location."
                                                                        label="text"
                                                                        :options="locationArr">
                                                            </v-select>
                                                            <div class="field-error">{{fuelMap.location_error}}</div>
                                                        </td>
                                                        <td>
                                                            <!-- <input v-model="fuelMap.tank" name="tank" class="form form-control" @keypress="isIntegerCheck($event)" placeholder="Input Tank Number."
                                                                        /> -->
                                                            <v-select v-model="fuelMap.tank" name="tank" placeholder="Select Tank."
                                                            label="text"
                                                            :options="tankArr">
                                                            </v-select>
                                                            <div class="field-error">{{fuelMap.tank_error}}</div>
                                                        </td>
                                                        <td>
                                                            <input v-model="fuelMap.pump" name="pump" @keypress="isIntegerCheck($event)" class="form form-control" placeholder="Input Pump Number."
                                                                        />
                                                            <div class="field-error">{{fuelMap.pump_error}}</div>
                                                        </td>
                                                        <td class="text-center valign-middle">
                                                            <template>
                                                                <span class="close-row"> <a href="javascript:void(0)" v-on:click="removeElement(index);"> × </a></span>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="btn-groups">
                                            <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                                <i class="fp-add"></i> Add Line Item
                                            </button>
                                        </div>
                                        
                                    </template>
                                <!-- </div> -->
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createFuelPumpMapBtn" class="btn btn-primary" v-on:click.prevent="CreateFuelPumpMap">
                                        <i class="fp-reload"> </i>  Save
                                    </button>
                                    <button type="submit" id="cancelPurchaseOrderBtn" class="btn btn-tertiary" v-on:click.prevent="BackFuelMappingList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    // import { store } from "../store/extraFeaturesStore.js";
    import {commonMixins} from '../mixins/commonMixins';
    import {contractMixins} from '../mixins/contractMixins';
    
    export default {
        name: "FuelTankPumpMapping",
        mixins:[commonMixins,contractMixins],
        data:() => ({
                fuelTankPumpMapper:[{
                    id:0,
                    location:'',
                    location_error:'',
                    tank:'',
                    tank_error:'',
                    pump:'',
                    pump_error:''
                }],
                cantAccessPage:'',
                permissions: [],
                loading:false,
                locationArr:[],
                tankArr:[{text:'Diesel Tank 1',value:1},{text:'DEF Tank 2',value:2}]
                // location:'',
                // location_error:'',
                // tank:'',
                // tank_error:'',
                // pump:'',
                // pump_error:''
            }),
        watch: {

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_fuel_ticket') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            }
        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            self.loadFieldData(['location']);

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadMapperItem(segments[3]);
            }
        },
        methods: {
            BackFuelMappingList:function(){
                var self = this;
                self.$router.push('/fuel-pump-map/list');
            },
            addRow:function(){
                var self = this;
                var error = false;
                var index = self.fuelTankPumpMapper.length-1;
                var checkArr = [];
                if (self.fuelTankPumpMapper.length){
                    for(var i=0;i<self.fuelTankPumpMapper.length;i++){
                        if (self.fuelTankPumpMapper[i] != null){
                            self.fuelTankPumpMapper[i].location_error = '';
                            self.fuelTankPumpMapper[i].tank_error = '';
                            self.fuelTankPumpMapper[i].pump_error = '';
                            if(self.fuelTankPumpMapper[i].location != null && self.fuelTankPumpMapper[i].location.value){
                               
                            }else{
                                self.fuelTankPumpMapper[i].location_error = 'Location Required';
                                error=true;
                            }
                            if (self.fuelTankPumpMapper[i].tank == '' || self.fuelTankPumpMapper[i].tank == null || !self.fuelTankPumpMapper[i].tank.value){
                                self.fuelTankPumpMapper[i].tank_error = 'Tank Required';
                                error=true;
                            }
                            if (self.fuelTankPumpMapper[i].pump == '' || self.fuelTankPumpMapper[i].pump == null){
                                self.fuelTankPumpMapper[i].pump_error = 'Pump Required';
                                error=true;
                            }
                            if (!error){
                                var uid = self.fuelTankPumpMapper[i].location.value+'_'+self.fuelTankPumpMapper[i].tank.text+'_'+self.fuelTankPumpMapper[i].pump;
                                if (checkArr.includes(uid)){
                                    self.fuelTankPumpMapper[i].location_error = 'Mapping already selected';
                                    error=true;
                                }else{
                                    checkArr.push(uid);
                                }
                            }
                           
                        }
                    }
                }
                if (!error){
                    self.fuelTankPumpMapper.push({
                                                id:0,
                                                location:'',
                                                location_error:'',
                                                tank:'',
                                                tank_error:'',
                                                pump:'',
                                                pump_error:''
                                            });
                }

            },
            removeElement:function(index){
                var self = this;

                if (self.fuelTankPumpMapper[index].id > 0){
                    self.$swal({
                            title: 'Are you sure that you want to delete this Mapping?',
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                            showCloseButton: false,
                            showLoaderOnConfirm: true
                        }).then((result) => {
                            if (result.value) {
                                self.loading = true;
                                $.ajax({
                                url: process.env.ROOT_API + "/fuel-tank-mapping/remove",
                                type: "POST",
                                data:{
                                    id:self.fuelTankPumpMapper[index].id
                                },
                                headers: this.ajxHeaders,
                                dataType: "json",
                                success: function (data) {
                                    self.loading = false;
                                    self.fuelTankPumpMapper.splice(index,1);
                                    if (self.fuelTankPumpMapper.length < 1){
                                        self.fuelTankPumpMapper.push({
                                                                    id:0,
                                                                    location:'',
                                                                    location_error:'',
                                                                    tank:'',
                                                                    tank_error:'',
                                                                    pump:'',
                                                                    pump_error:''
                                                                });
                                    }
                                },
                                error: function (jqXHR, exception) {

                                    self.loading = false;
                                    self.generateStatusCodeMessage(jqXHR,false,'fuel-tank-mapping-load')
                                }
                            });

                        } else {
                        console.log("no");
                        }
                    });
                   
                }else{
                    self.fuelTankPumpMapper.splice(index,1);
                    if (self.fuelTankPumpMapper.length < 1){
                    self.fuelTankPumpMapper.push({
                                                id:0,
                                                location:'',
                                                location_error:'',
                                                tank:'',
                                                tank_error:'',
                                                pump:'',
                                                pump_error:''
                                            });
                }
                }
                

            },
            CreateFuelPumpMap()
            {
                var self = this;
                var fields =[];
                var error = false;
                var checkArr = [];
                if (self.fuelTankPumpMapper.length){
                    for(var i=0;i<self.fuelTankPumpMapper.length;i++){
                        if (self.fuelTankPumpMapper[i] != null){
                            self.fuelTankPumpMapper[i].location_error = '';
                            self.fuelTankPumpMapper[i].tank_error = '';
                            self.fuelTankPumpMapper[i].pump_error = '';
                            if(self.fuelTankPumpMapper[i].location != null && self.fuelTankPumpMapper[i].location.value){
                               
                            }else{
                                self.fuelTankPumpMapper[i].location_error = 'Location Required';
                                error=true;
                            }
                            if (self.fuelTankPumpMapper[i].tank == '' || self.fuelTankPumpMapper[i].tank == null || !self.fuelTankPumpMapper[i].tank.value){
                                self.fuelTankPumpMapper[i].tank_error = 'Tank Required';
                                error=true;
                            }
                            if (self.fuelTankPumpMapper[i].pump == '' || self.fuelTankPumpMapper[i].pump == null){
                                self.fuelTankPumpMapper[i].pump_error = 'Pump Required';
                                error=true;
                            }
                            if (!error){
                                var uid = self.fuelTankPumpMapper[i].location.value+'_'+self.fuelTankPumpMapper[i].tank+'_'+self.fuelTankPumpMapper[i].pump;
                                if (checkArr.includes(uid)){
                                    self.fuelTankPumpMapper[i].location_error = 'Mapping already selected';
                                    error=true;
                                }else{
                                    checkArr.push(uid);
                                }
                            }
                           
                        }
                    }
                }

                if (!error){
                    self.loading = true;

                    fields.push({name:"fuelTankPumpMapper",value:JSON.stringify(self.fuelTankPumpMapper)});

                    $.ajax({
                        url: process.env.ROOT_API + "/fuel-tank-mapping/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.code == 201){
                                self.$swal('',data.message,'info');
                                return;
                            }
                            self.$router.push('/fuel-pump-map/list');
                            // self.loadFeatures();
                        },
                        error: function (jqXHR, exception) {

                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,false,'fuel-tank-mapping-create')
                        }
                    });
                }
            },

            loadMapperItem:function(id){
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-tank-mapping/"+id,
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.fuelTankPumpMapper = [];
                        // self.fuelTankPumpMapper = data.content;
                        var mapData = data.content;

                        var tankNo = "";
                        if ( mapData.tank_no == 1 ) {
                            tankNo = "Diesel Tank 1";
                        } else {
                            tankNo = "DEF Tank 2";
                        }

                        self.fuelTankPumpMapper.push({
                                                id:mapData.id,
                                                location:{text:mapData.company_name+' | '+mapData.loc_code,value:mapData.location_id},
                                                location_error:'',
                                                tank:{text:tankNo,value:mapData.tank_no},
                                                tank_error:'',
                                                pump:mapData.pump_no,
                                                pump_error:''
                                            });

                        // self.loadFeatures();
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'fuel-tank-mapping-load')
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/FuelPumpMapper.vue